import { useCallback, useEffect, useRef, useState } from 'react'

import { fetchCityPlanMissionStats } from 'Module/graphQL'
import { readGraphQLData } from 'Components/PowerBanks/hooks'

/**
 * The plan's totals / per-status / per-week counts, with a `refetch` for
 * after anything changed missions. Out-of-order responses are dropped.
 * @param {string|number} cityPlanId
 * @returns {{stats: ?object, loading: boolean, error: ?string, refetch: function}}
 */
export const useCityPlanStats = cityPlanId => {
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(Boolean(cityPlanId))
  const [error, setError] = useState(null)
  const requestRef = useRef(0)

  const refetch = useCallback(async () => {
    if (!cityPlanId) return
    const requestId = (requestRef.current += 1)
    setLoading(true)
    try {
      const data = await readGraphQLData(
        await fetchCityPlanMissionStats({ cityPlanId }),
      )
      if (requestId !== requestRef.current) return
      const node = data.cityPlans.edges[0] && data.cityPlans.edges[0].node
      setStats(node ? node.missionStats : null)
      setError(null)
    } catch (loadError) {
      if (requestId !== requestRef.current) return
      setError(loadError.message)
    } finally {
      if (requestId === requestRef.current) setLoading(false)
    }
  }, [cityPlanId])

  useEffect(() => {
    refetch()
  }, [refetch])

  return { stats, loading, error, refetch }
}
